import styles from "./custom-select.module.css";
import { Input, Select, Typography } from "antd";

const { Text } = Typography;
export function CustomSelect({
  id,
  label,
  value,
  onChange,
  placeholder,
  mode,
  size = "middle",
  variant = "outlined",
  allowClear,
  showSearch = false,
  disabled,
  status,
  labelColor = "#000",
  children,
  style = { width: "100%" },
  errorMessage,
  className,
  onSearch,
  onClear,
  onPopupScroll,
  loading = false,
  showRequired = false,
  showOptional = false,
  rest,
}) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <div style={{ display: "flex", flexDirection: "column" }}>
      {label ? (
        <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
          {label}
          {showRequired ? (
            <span style={{ color: "red" }}>*</span>
          ) : showOptional ? (
            <span style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
          ) : null}
        </div>
      ) : null}
      <Select
        {...rest}
        id={id}
        mode={mode}
        size={size}
        value={value === "" || value === 0 ? undefined : value}
        variant={variant}
        className={className}
        allowClear={allowClear}
        loading={loading}
        showSearch={showSearch}
        disabled={disabled}
        style={style}
        placeholder={placeholder}
        status={status}
        onChange={onChange}
        onSearch={onSearch}
        onClear={onClear}
        onPopupScroll={onPopupScroll}
        filterOption={(input, option) => {
          const label =
            typeof option?.children === "string" ? option.children : "";
          return label.toLowerCase().includes(input.toLowerCase());
        }}
      >
        {children}
      </Select>
      <Text type="danger" style={{ marginTop: 5 }}>
        {errorMessage}
      </Text>
    </div>
  );
}

export default CustomSelect;
